
import React, { useEffect } from "react";
import { useForm, Control, FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import useRequest from "../../components/hooks/use-request";
import { showToast } from "../../components/toast";
import BackgroundCard from "../../components/background-card";
import ForgotPasswords from "../../components/auth/forgot-password";

const ForgotPassword = () => {
  const { loading, makeRequest } = useRequest("/auth/forgot-password", "POST");
    const navigate = useNavigate();
    const { handleSubmit, control, setValue } = useForm<FieldValues>();
  
    useEffect(() => {
      const user = localStorage.getItem("user");
      if (user) {
        const userInfo = JSON.parse(user);
        setValue("email", userInfo.email);
        setValue("password", userInfo.password);
      }
    }, [setValue]);
  
    const handleForgotPassowrd = handleSubmit(async (formData) => {
      const userForgotPassword = {
        email: formData.email,
      };
      const [response] = await makeRequest(userForgotPassword);
  
      if (response.label) {
        showToast(response.message, true, {
          position: "top-right",
        });
  
        navigate("/reset-password");
      } else {
        // showToast(response.message, false, {
        //   position: "top-right",
        // });
      }
    });
  return (
    <>
      <BackgroundCard>
        <ForgotPasswords handleForgotPassowrd={handleForgotPassowrd} control={control} loading={loading}/>
      </BackgroundCard>
    </>
  );
};

export default ForgotPassword;
